import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { NewsModal, useCan, useSelectedLocation } from "components";
import { useClickArticleNotificationMutation } from "components/NewsStripe/hooks";
import "components/NewsStripe/NewsStripe.scss";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { useUnreadArticlesQuery } from "modules/NewsDashboard/hooks";
import { PATHS } from "router/paths";

import type { Article } from "models";

export const NewsStripe = () => {
  const { t } = useTranslation();

  const [isArticleOpened, setIsArticleOpened] = useState(false);
  const [modalArticles, setModalArticles] = useState<Article[]>([]);

  const { selectedLocation } = useSelectedLocation();
  const { unreadArticles = [] } = useUnreadArticlesQuery(selectedLocation?.id);
  const { mutateAsync: clickArticleNotification } = useClickArticleNotificationMutation();

  const canUpdateStripeCount = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.ArticlesStripeCount);
  const appointmentDetailPage = useRouteMatch(PATHS.APPOINTMENT_DETAIL);

  const shouldShowNewsStripe = !appointmentDetailPage && !isArticleOpened && unreadArticles.length > 0;
  const latestArticle = unreadArticles[0];

  const handleOpenNewsModal = async () => {
    setModalArticles([...unreadArticles]);
    setIsArticleOpened(true);
    if (canUpdateStripeCount) await clickArticleNotification({ article_id: latestArticle.id, article_opened: true });
  };

  const handleCloseStripe = async () => {
    setIsArticleOpened(false);
    if (canUpdateStripeCount) await clickArticleNotification({ article_id: latestArticle.id, article_opened: false });
    setModalArticles([]);
  };

  const handleCloseModal = () => {
    setIsArticleOpened(false);
    setModalArticles([]);
  };

  return (
    <>
      {shouldShowNewsStripe && (
        <div className="NewsStripe">
          <div className="stripe">
            <div className="stripe-content">
              <span>{latestArticle.title}</span>
              <span className="link" onClick={handleOpenNewsModal}>
                {t("v8_learn_more", "Learn more")}.
              </span>
            </div>
            <div className="close" onClick={handleCloseStripe}>
              <Icon className="x mark" />
            </div>
          </div>
        </div>
      )}

      <NewsModal articles={modalArticles} isOpen={isArticleOpened} onClose={handleCloseModal} />
    </>
  );
};
